module.exports = __webpack_public_path__ + "media/images/promo/stopwatch-031beab8f26a71a757bdd19d5495b6505d584509af5eacedff1cdb01f84c2775.png";